/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Agent_Readiness_Check_Cli_Non_InteractiveInputs */

const en_directory_agent_readiness_check_cli_non_interactive = /** @type {(inputs: Directory_Agent_Readiness_Check_Cli_Non_InteractiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non-interactive CLI`)
};

const zh_directory_agent_readiness_check_cli_non_interactive = /** @type {(inputs: Directory_Agent_Readiness_Check_Cli_Non_InteractiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`非交互式命令`)
};

/**
* | output |
* | --- |
* | "Non-interactive CLI" |
*
* @param {Directory_Agent_Readiness_Check_Cli_Non_InteractiveInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_agent_readiness_check_cli_non_interactive = /** @type {((inputs?: Directory_Agent_Readiness_Check_Cli_Non_InteractiveInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Agent_Readiness_Check_Cli_Non_InteractiveInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_agent_readiness_check_cli_non_interactive(inputs)
	return zh_directory_agent_readiness_check_cli_non_interactive(inputs)
});
export { directory_agent_readiness_check_cli_non_interactive as "directory.agent_readiness.check.cli_non_interactive" }